<button [matMenuTriggerFor]="usermenu" class="profile-button mat-body-medium" (click)="onResetMenu()">
	<app-user-avatar [user]="user()"/>
</button>

<mat-menu #usermenu class="user-menu">
		<app-profile-info/>
  <hr>
  <!-- <button mat-menu-item (click)="onExpandDesign($event)">
    <ogs-m3-icon icon="eclipse"/>
    <div class="text-icon mat-body-medium">Design
      <ogs-m3-icon icon="chevron-down"/>
    </div>
  </button>
  <hr> -->
  <!-- @if (isButtonVisible()) {
    <button mat-menu-item>
      <ogs-m3-icon icon="sun"/>
      <span class="mat-body-medium">Light</span>
    </button>
    <button mat-menu-item>
      <ogs-m3-icon icon="moon"/>
      <span class="mat-body-medium">Dark</span>
    </button>
    <hr>
  } -->

		<app-language-select-menu-item/> 
  <hr/>


		<button mat-menu-item
		 (click)="onChangePassword()">
			<ogs-m3-icon icon="key"/>
			<span class="mat-body-medium">{{"Passwort ändern" | translate : "user-menu-change-password"}}</span>
	</button>
	<hr>
	<button mat-menu-item (click)="onLogout()">
		<ogs-m3-icon icon="power-off"/>
		<span class="mat-body-medium">{{"Abmelden" | translate : "user-menu-logout"}}</span>
	</button>
</mat-menu>

<!-- <mat-menu #languageMenu xPosition="before" class="language-menu-panel">
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('de')">Deutsch</button>
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('en')">English</button>
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('fr')">Français</button>
</mat-menu> -->
